import React, { Fragment, useContext } from 'react'
import injectSheet from 'react-jss'
import SubHead from '../../../sub-head/sub-head'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { useHistory, withRouter } from 'react-router-dom'
import CreateLesson from '../create-lesson/create-lesson.container'
import classNames from 'classnames'
import LessonsContext from '../lessons.context'

const styles = ({ COLORS }) => ({
  container: {
    fontSize: '16px',
    position: 'relative',
    zIndex: '20',
    height: '70px',
    '@media (max-width: 767px)': {
      fontSize: '14px',
      height: '50px'
    }
  },
  newLesson: {
    position: 'absolute',
    right: '20px',
    color: 'var(--blue)',
    font: 'var(--body)',
    lineHeight: '1.2',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: '4px'
    },
    '&:hover': {
      color: 'var(--blue-)'
    }
  },
  title: {
    textAlign: 'center',
    margin: '0',
    font: 'var(--heading--)',
    color: 'var(--gray-)',
    width: '100%'
  },
  pobble365: {
    display: 'none',
    '@media (min-width: 768px)': {
      position: 'absolute',
      color: 'var(--blue)',
      font: 'var(--body-)',
      textDecoration: 'none',
      top: '28px',
      left: '20px',
      display: 'block',
      fontWeight: 'bold'
    }
  },
  extraWord: {
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'inline'
    }
  }
})

const LessonsHead = ({ classes, location }) => {
  const { createLessonOpened } = useContext(LessonsContext)
  const history = useHistory()
  return (
    <SubHead className={classes.container}>
      <h2 className={classes.title}>My lessons</h2>
      <Fragment>
        <span
          role="button"
          onClick={() => {
            history.push('/new')
          }}
          className={classNames(classes.newLesson, 'metrics__new-lesson')}>
          <FontAwesomeIcon icon={faPlusCircle} />
          New lesson
        </span>
        <CreateLesson
          onClose={() => history.push('/')}
          isOpen={createLessonOpened}
        />
      </Fragment>
    </SubHead>
  )
}

export default withRouter(injectSheet(styles)(LessonsHead))
